// Fetch list

export const FETCH = 'companyCostCenters.FETCH'
export const FETCH_STARTED = 'companyCostCenters.FETCH_STARTED'
export const FETCH_FULFILLED = 'companyCostCenters.FETCH_FULFILLED'
export const FETCH_REJECTED = 'companyCostCenters.FETCH_REJECTED'
export const FETCH_CANCELLED = 'companyCostCenters.FETCH_CANCELLED'

export const SORTING_CHANGED = 'companyCostCenters.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'companyCostCenters.FETCH_ONE'
export const FETCH_ONE_STARTED = 'companyCostCenters.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'companyCostCenters.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'companyCostCenters.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'companyCostCenters.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'companyCostCenters.SAVE'
export const SAVE_STARTED = 'companyCostCenters.SAVE_STARTED'
export const SAVE_FULFILLED = 'companyCostCenters.SAVE_FULFILLED'
export const SAVE_REJECTED = 'companyCostCenters.SAVE_REJECTED'
export const SAVE_CANCELLED = 'companyCostCenters.SAVE_CANCELLED'

// Delete

export const DELETE = 'companyCostCenters.DELETE'
export const DELETE_STARTED = 'companyCostCenters.DELETE_STARTED'
export const DELETE_FULFILLED = 'companyCostCenters.DELETE_FULFILLED'
export const DELETE_REJECTED = 'companyCostCenters.DELETE_REJECTED'
export const DELETE_CANCELLED = 'companyCostCenters.DELETE_CANCELLED'

// Export

export const EXPORT = 'companyCostCenters.EXPORT'
export const EXPORT_FULFILLED = 'companyCostCenters.EXPORT_FULFILLED'
